import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../Auth/context/AuthContext";

export default function useContactTypes() {
  const { auth } = useContext(AuthContext);
  const [types, setTypes] = useState<string[]>([]);

  useEffect(() => {
    if (!auth?.token) return;
    axios
      .get("/api/myteconstruction/contact-types", {
        headers: { Authorization: `Bearer ${auth.token}` },
      })
      .then((resp) => {
        setTypes(resp.data.data || []);
      })
      .catch((err) => {
        console.error("Failed to load contact types:", err);
      });
  }, [auth?.token]);

  return types;
}